import { commonStore } from "stores/common-stores";
import styles from "./loading.module.scss";

const Loading = () => {
  const { isLoading } = commonStore();

  return (
    <>
      {/* 로딩 중일 때, 또는 isChangeDetectionMode일 때는 isChangeDetectionLoading이 true일 때 로딩 중임을 표시  */}
      {isLoading && (
        <div className={styles["loading__container"]}>
          <div className={styles["box"]}>
            <div className={styles["animate-logo"]}>
              <div className={styles["logo-1"]}></div>
              <div className={styles["logo-2"]}></div>
              <div className={styles["logo-3"]}></div>
              <div className={styles["logo-4"]}></div>
              <div className={styles["logo-5"]}></div>
              <div className={styles["logo-6"]}></div>
              <div className={styles["logo-7"]}></div>
            </div>
            <div className={styles["animate-text"]}>Please wait a moment.</div>
          </div>
        </div>
      )}
    </>
  );
};

export default Loading;
